export const HEADER_ACCOUNT_TOKEN = "X-FACNT";
